import React from "react";
import IndustryPage from "../pages/IndustryPage";
import aviationData from "../translation/industries/aviation.json"; // Import the aviation data
import AviationHero from "../assets/images/industries/aviationHero.png"; // Import the aviation hero image
import Airworthy from "../assets/images/solutions/airworthy.png"; // Image for fallback
import { Helmet } from "react-helmet";

import {
  IconPlane,
  IconRefresh,
  IconCheck,
  IconBellRinging,
  IconLogout2,
  IconReport,
  IconCloudComputing,
} from "@tabler/icons-react"; // Import necessary icons

// Icon mapping for aviation industry
const iconMapping = {
  IconPlane,
  IconRefresh,
  IconCheck,
  IconBellRinging,
  IconLogout2,
  IconReport,
  IconCloudComputing,
};

// Image mapping for aviation industry
const imageMapping = {
  airworthy: Airworthy,
};

const Aviation = () => {
  return (
    <>
      <Helmet>
        <title>Aviation | Innaxys</title>
        <meta name="description" content="Airworthiness Management" />
      </Helmet>
      <IndustryPage
        data={aviationData} // Pass in the aviation data
        heroImage={AviationHero} // Pass in the aviation hero image
        iconMapping={iconMapping} // Pass in the icon mapping
        imageMapping={imageMapping} // Pass in the image mapping
        translationKey="aviation" // Pass the translation key for aviation
      />
    </>
  );
};

export default Aviation;
